import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import './services/keepAliveService';

// Capture le type d'URL Supabase (invite, recovery…) AVANT que le SDK
// n'efface le hash — createClient() peut le faire de façon synchrone.
// On conserve la valeur dans sessionStorage pour que les composants puissent
// la lire même si le hash est déjà vide au moment de leur montage.
(function captureSupabaseUrlType() {
  // Implicit flow : type=invite dans le hash (#access_token=...&type=invite)
  const hashParams = new URLSearchParams(window.location.hash.slice(1));
  const typeFromHash = hashParams.get('type');
  // PKCE flow : type=invite dans les query params (?code=...&type=invite)
  const queryParams = new URLSearchParams(window.location.search);
  const typeFromQuery = queryParams.get('type');
  const type = typeFromHash || typeFromQuery;
  if (type) {
    sessionStorage.setItem('sb_url_type', type);
  }
})();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)